import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, FolderPlus, CheckCircle2 } from "lucide-react";
import { api } from "../../lib/api";

export default function ModuleToProject({ moduleKey, item, onRefresh }) {
  const [busy, setBusy] = useState(false);
  const created = !!item.project_id;
  const eligible = moduleKey === "opportunities" ? item.etapa === "ganada" : item.estado === "aceptada";

  const create = async () => {
    setBusy(true);
    try {
      await api.post(`/mod/${moduleKey}/items/${item.id}/to-project`);
      toast.success("Proyecto creado en Project Management");
      onRefresh?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-4 border-t border-navy/10 pt-4" data-testid="module-toproject">
      {created ? (
        <Link to="/os/mod/projects" className="btn btn-ghost w-full justify-center text-emerald-600" data-testid="toproject-created">
          <CheckCircle2 className="w-4 h-4" /> Proyecto creado — ver en Projects
        </Link>
      ) : (
        <>
          <button onClick={create} disabled={busy} className="btn btn-primary w-full justify-center" data-testid="toproject-btn">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <FolderPlus className="w-4 h-4" />} Crear Proyecto
          </button>
          {!eligible && <p className="text-[11px] text-navy/40 mt-1.5 text-center">Sugerido cuando la {moduleKey === "opportunities" ? "oportunidad esté Ganada" : "cotización esté Aceptada"} (arrastra cliente, valor y alcance).</p>}
        </>
      )}
    </div>
  );
}
